import { useEffect } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from './components/Home/Home.tsx';
import Coupleroom from './components/Aminities_section/Coupleroom.tsx';
import DaysRentPage from './components/Aminities_section/DaysRentPage.tsx';
import FamilyRoomPage from './components/Aminities_section/FamilyRoomPage.tsx';
import FamilyRoomSwimPage from './components/Aminities_section/FamilyRoomSwimPage.tsx';
import FullVillaPage from './components/Aminities_section/FullVillaPage.tsx';
import GroupRoomPage from './components/Aminities_section/GroupRoomPage.tsx';
import HoneyMoonPage from './components/Aminities_section/HoneyMoonPage.tsx';
import RoomSwimPage from './components/Aminities_section/RoomSwimPage.tsx';
import { useLocation } from 'react-router-dom';


const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};const App = () => {
  return (
    <BrowserRouter>
          <ScrollToTop /> 

      <Switch>
        <Route exact path="/" component={Home} />
        <Route  path="/coupleroom" component={Coupleroom} />
        <Route  path="/daysrentpage" component={DaysRentPage} />
        <Route  path="/familyroompage" component={FamilyRoomPage} />
        <Route  path="/familyroomswinpage" component={FamilyRoomSwimPage} />
        <Route  path="/fullvilla" component={FullVillaPage} />
        <Route  path="/grouproompage" component={GroupRoomPage} />
        <Route  path="/honeymoonpage" component={HoneyMoonPage} />
        <Route  path="/roomswimpage" component={RoomSwimPage} />

      </Switch>
    </BrowserRouter>
  );
}

export default App;

